export const FAQ_ACTION = 'FAQ_ACTION';
export const FAQ_SUCCESS_ACTION = 'FAQ_SUCCESS_ACTION';
export const FAQ_FAILURE_ACTION = 'FAQ_FAILURE_ACTION';
